import React, { useEffect, useState } from 'react'

import { PluckingRooster as PluckingRoosterGame } from './PluckingRooster/PluckingRooster'
import { SubmitGame as BLSubmitGame, ValidatePlayer as BLValidatePlayer } from './../../../utilities/BL/Admin/Games/PluckingRooster'

import { useFloatMessage, MESSAGE_TYPE } from './../../Providers/FloatMessage'
import { ValidateSqlInjection as BLValidateSqlInjection } from './../../../utilities/BL/Security'


// import React, { useState, useEffect } from 'react';
// import { MESSAGE_TYPE, useFloatMessage } from './../../Providers/FloatMessage'; 
// // Asegúrate de importar tus componentes y lógica BL
// import { PluckingRoosterGame } from './PluckingRoosterGame'; // Ajusta la ruta si es necesario
// import { BLValidateSqlInjection, BLValidatePlayer, BLSubmitGame } from './../../BL/Admin/Games/PluckingRooster';


const PluckingRooster = () => {
    const { showMessage } = useFloatMessage();

    // Estado del flujo
    const [step, setStep] = useState('register'); // register, game, sending, done, played, resendPoints
    const [userData, setUserData] = useState({
        fullName: '',
        email: '',
        phoneNumber: '',
        companionType: 'amigos'
    });
    const [finalScore, setFinalScore] = useState(0);
    const [isLoading, setIsLoading] = useState(false); // Nuevo estado para feedback visual

    // 1. Manejo del Formulario
    const handleInputChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value });
    };

    // VALIDACIÓN AL CARGAR (LocalStorage)
    useEffect(() => {
        const played = localStorage.getItem('rooster_played');

        if (played === 'true') {
            setStep('played'); // O mostrar una pantalla de "Ya jugaste"
        }

        return () => {
            const gameContainer = document.getElementById('PluckingRooster__Game');
            if (gameContainer) gameContainer.style.overflow = 'visible';
        }
    }, []);

    const handleRegister = async (e) => {
        e.preventDefault();
        
        // 1. Validar campos vacíos
        if (!userData.fullName || !userData.email || !userData.phoneNumber) {
            showMessage({ type: MESSAGE_TYPE.BAD, text: `Completa todos los campos` });
            return;
        }

        setIsLoading(true); // Bloqueamos botón

        // 2. Validación de Inyección SQL
        const isNameThreat = await BLValidateSqlInjection(userData.fullName);
        const isEmailThreat = await BLValidateSqlInjection(userData.email);
        const isPhoneThreat = await BLValidateSqlInjection(userData.phoneNumber);

        if (isNameThreat || isEmailThreat || isPhoneThreat) {
            setIsLoading(false);
            showMessage({ type: MESSAGE_TYPE.BAD, text: `Caracteres no permitidos en el formulario.` });
            return; // Bloqueamos el avance
        }

        // 3. VALIDAMOS CONTRA EL BACKEND
        const validation = await BLValidatePlayer(userData.email, userData.phoneNumber);

        setIsLoading(false); // Desbloqueamos

        if (!validation.success) {
            setStep('played'); // "Ya has participado..."
            return; // NO DEJA AVANZAR
        }

        const gameContainer = document.getElementById('PluckingRooster__Game');
        if (gameContainer) gameContainer.style.overflow = 'hidden';
        
        // Si pasa, iniciamos el juego
        setStep('game');
    };
    
    // 2. Callback cuando el juego termina
    const handleGameFinish = async (score) => {
        
        // -----------------------------------------------------------------------
        // NUEVO: Delay de seguridad (3 segundos)
        // Mantiene el modal de "¡TIEMPO!" visible para absorber clicks nerviosos
        // -----------------------------------------------------------------------
        await new Promise(resolve => setTimeout(resolve, 3000));

        // Guardamos en LocalStorage para bloquear futuros intentos inmediatos
        localStorage.setItem('rooster_played', 'true');

        const gameContainer = document.getElementById('PluckingRooster__Game');
        if (gameContainer) gameContainer.style.overflow = 'visible';

        setFinalScore(score);
        setStep('sending');

        // --- LLAMADA A LA CAPA BL ---
        const result = await BLSubmitGame(userData, score);

        if (result.success) {
            // Éxito
            showMessage({ type: MESSAGE_TYPE.SUCCESS, text: `Puntaje enviado con éxito` });
            setStep('done');
        } else {
            // Error (Ya manejado y traducido en el BL)
            showMessage({ type: MESSAGE_TYPE.BAD, text: 'Ha habido un error al intentar enviar tu puntaje. Inténtalo nuevamente.' });
            setStep('resendPoints'); 
        }
    };

    const ResendPoints = async () => {
        // Aseguramos bloqueo por si acaso
        localStorage.setItem('rooster_played', 'true');

        const gameContainer = document.getElementById('PluckingRooster__Game');
        if (gameContainer) gameContainer.style.overflow = 'visible';

        setStep('sending');

        // --- LLAMADA A LA CAPA BL ---
        const result = await BLSubmitGame(userData, finalScore);

        if (result.success) {
            showMessage({ type: MESSAGE_TYPE.SUCCESS, text: `Puntuación enviada con éxito` });
            setStep('done');
        } else {
            showMessage({ type: MESSAGE_TYPE.BAD, text: '¡Ups! Ha habido un error al intentar enviar tu puntaje' });
            setStep('resendPoints'); 
        }
    };

    
    return (
        <div id='PluckingRooster__Game' style={{ width: '100vw', height: '100vh' }}>
            
            {step === 'register' && (
                <>
                    <div className="container flex flex-col justify-center h-full bg-gray-100 pb-5"> 
                        <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />
                        <p className="SelfieFan__Fan__Title">¡Bienvenid@ Aficionad@!</p>
                        <p className="SelfieFan__Fan__Text--Center">Participa por un regalo especial.</p>
                        <p className='Messages__Fan__Text--Center'>Obtén puntos cada vez que le pegues al gallito</p>

                        <p className='Messages__Fan__Text--Center'>La persona que obtenga más puntos y más rápido será ganador(a)</p>

                        <hr />

                        <p className='SelfieFan__Fan__Title mt-4'>¡Únete al juego!</p>

                        <label className='PluckingRooster__Instructions__Form__Labels' htmlFor='fullName'>Escribe tu nombre completo</label>
                        <input id="fullName" name="fullName" placeholder="Escribe tu nombre" onChange={handleInputChange} className="PluckingRooster__Instructions__Form__Inputs" />

                        <label className='PluckingRooster__Instructions__Form__Labels' htmlFor='name'>Correo electrónico</label>
                        <input id="email" name="email" placeholder="Escribe tu correo" onChange={handleInputChange} className="PluckingRooster__Instructions__Form__Inputs" />

                        <label className='PluckingRooster__Instructions__Form__Labels' htmlFor='phoneNumber'>WhatsApp o Teléfono</label>
                        <input id="phoneNumber" name="phoneNumber" placeholder="Ej. 6641234567" onChange={handleInputChange} className="PluckingRooster__Instructions__Form__Inputs" />
                        
                        <label className='PluckingRooster__Instructions__Form__Labels' htmlFor='phoneNumber'>¿Con quién nos acompañas hoy?</label>
                        {/* Select simple para Acompañante */}
                        <select name="companionType" onChange={handleInputChange} className='PluckingRooster__Instructions__Form__List'>
                            <option value="amigos">Amig@s</option>
                            <option value="familia">Familia</option>
                            <option value="pareja">Pareja</option>
                            <option value="trabajo">Compañer@s de trabajo</option>
                            <option value="solo">Sol@</option>
                        </select>

                        {isLoading ? (
                            <button className="Btn__Adsl--RedOutline PluckingRooster__Instructions__Form__Button" disabled={true}>Iniciando juego...</button>
                        ) : (
                            <button onClick={handleRegister} className="Btn__Adsl--Red PluckingRooster__Instructions__Form__Button">Jugar ahora</button>
                        )}
                    </div>

                    <footer className="text-center mt-3 FooterCredits">
                        Hecho con ♥ por <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=footer&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='text-dark'>Five Digital Minds</a> | 2026
                    </footer>
                </>
            )}

            {step === 'game' && (
                <PluckingRoosterGame onGameFinish={handleGameFinish} initialDuration={15} />
            )}

            {step === 'sending' && (
                <>
                    <div className="container flex flex-col justify-center h-full bg-gray-100 pb-5">
                        <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia mt-3" alt="Logo" />
                        <p className="SelfieFan__Fan__Title mt-3">¡Muy bien{(userData && userData?.fullName && userData.fullName !== '') && ` ${userData.fullName}`}!</p>
                        <p className="SelfieFan__Fan__Text--Center">Un momento... estamos guardando tu puntuación.</p>
                        <p className="SelfieFan__Fan__Text--Center">{finalScore} puntos</p>
                        <p className="SelfieFan__Fan__Text--Center">No salgas de esta pantalla.</p>

                        <hr />

                        <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='SelfieFan__Sent__Banner'>
                            <img src='/img/advertising/fdm/banner/five-digital-minds-agradecimiento.gif' alt='Publicidad' className='d-block m-auto SelfieFan__Sent__Banner__Image' />
                        </a>
                        <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center d-block'>Contactar ahora</a>

                        <hr />

                        <p className='text-center mb-0'>¿Quieres conocer más de esta tecnología?</p>
                        <p className='text-center mb-0'>Five Digital Minds está listo para ti</p>
                        <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner_text&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center'>Contactar ahora</a>
                    </div>

                    <footer className="text-center mt-3 FooterCredits">
                        Hecho con ♥ por <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=footer&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='text-dark'>Five Digital Minds</a> | 2026
                    </footer>
                </>
            )}

            {step === 'done' && (
                <>
                    <div className="SelfieFan__Sent container">
                        <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia mt-3" alt="Logo" />
                        <p className="fs-1 mb-0 text-success"><i className="bi bi-check-circle-fill"></i></p>
                        <p className="SelfieFan__Sent__Title mt-3 mb-0">¡Listo!</p>
                        <p className='Messages__Fan__Text--Center mb-0'>Tu puntaje ha sido enviado correctamente</p>
                        <p className='Messages__Fan__Text--Center mb-0'>¡{finalScore} puntos!</p>
                        <p className='Messages__Fan__Text--Center mb-0'>Podrás ir viendo en la pantalla del estadio el ranking para saber si has sido ganador(a)</p>
                        
                        <hr />

                        <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='SelfieFan__Sent__Banner'>
                            <img src='/img/advertising/fdm/banner/five-digital-minds-agradecimiento.gif' alt='Publicidad' className='d-block m-auto SelfieFan__Sent__Banner__Image' />
                        </a>
                        <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center d-block'>Contactar ahora</a>

                        <hr />

                        <p className='text-center mb-0'>¿Quieres conocer más de esta tecnología?</p>
                        <p className='text-center mb-0'>Five Digital Minds está listo para ti</p>
                        <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner_text&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center'>Contactar ahora</a>
                    </div>

                    <footer className="text-center mt-3 FooterCredits">
                        Hecho con ♥ por <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=footer&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='text-dark'>Five Digital Minds</a> | 2026
                    </footer>
                </>
            )}

            {step === 'played' && (
                <>
                    <div className="SelfieFan__Sent container">
                        <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia mt-3" alt="Logo" />
                        <p className="fs-1 mb-0 text-success"><i className="bi bi-check-circle-fill"></i></p>
                        <p className="SelfieFan__Sent__Title mt-3 mb-0">Gracias por tu participación</p>
                        <p className='Messages__Fan__Text--Center mb-0'>Tu puntaje fue enviado correctamente</p>
                        <p className='Messages__Fan__Text--Center mb-0'>Podrás ir viendo en la pantalla del estadio el ranking para saber si has sido ganador(a)</p>
                        
                        <hr />

                        <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='SelfieFan__Sent__Banner'>
                            <img src='/img/advertising/fdm/banner/five-digital-minds-agradecimiento.gif' alt='Publicidad' className='d-block m-auto SelfieFan__Sent__Banner__Image' />
                        </a>
                        <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center d-block'>Contactar ahora</a>

                        <hr />

                        <p className='text-center mb-0'>¿Quieres conocer más de esta tecnología?</p>
                        <p className='text-center mb-0'>Five Digital Minds está listo para ti</p>
                        <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner_text&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center'>Contactar ahora</a>
                    </div>

                    <footer className="text-center mt-3 FooterCredits">
                        Hecho con ♥ por <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=footer&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='text-dark'>Five Digital Minds</a> | 2026
                    </footer>
                </>
            )}

            {step === 'resendPoints' && (
                <>
                    <div className="SelfieFan__Sent container">
                        <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia mt-3" alt="Logo" />
                        <p className="fs-1 mb-0 text-danger"><i className="bi bi-x-circle-fill"></i></p>
                        <p className="mb-0">No ha sido posible enviar tu puntaje. Inténtalo nuevamente con el botón Enviar mi puntaje</p>
                        <button type='button' className='Btn__Adsl--RedOutlineTransparent mx-auto' onClick={() => ResendPoints()}>Enviar mi puntaje</button>
                        
                        <hr />

                        <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='SelfieFan__Sent__Banner'>
                            <img src='/img/advertising/fdm/banner/five-digital-minds-agradecimiento.gif' alt='Publicidad' className='d-block m-auto SelfieFan__Sent__Banner__Image' />
                        </a>
                        <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center d-block'>Contactar ahora</a>

                        <hr />

                        <p className='text-center mb-0'>¿Quieres conocer más de esta tecnología?</p>
                        <p className='text-center mb-0'>Five Digital Minds está listo para ti</p>
                        <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner_text&utm_campaign=fdm_capitanescdmx' target='_blank' className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center'>Contactar ahora</a>
                    </div>

                    <footer className="text-center mt-3 FooterCredits">
                        Hecho con ♥ por <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=footer&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='text-dark'>Five Digital Minds</a> | 2026
                    </footer>
                </>
            )}
        </div>
    );
};

export { PluckingRooster };






















// Funcional
// const PluckingRooster = () => {
//     const { showMessage } = useFloatMessage()


//     // Estado del flujo
//     const [step, setStep] = useState('register'); // register, game, sending, done, played, resendPoints
//     const [userData, setUserData] = useState({
//         fullName: '',
//         email: '',
//         phoneNumber: '',
//         companionType: 'amigos'
//     });
//     const [finalScore, setFinalScore] = useState(0)
//     const [isLoading, setIsLoading] = useState(false) // Nuevo estado para feedback visual


//     // 1. Manejo del Formulario
//     const handleInputChange = (e) => {
//         setUserData({ ...userData, [e.target.name]: e.target.value });
//     };

//     // VALIDACIÓN AL CARGAR (LocalStorage)
//     useEffect(() => {
//         const played = localStorage.getItem('rooster_played');

//         if (played === 'true') {
//             //alert("Ya has jugado anteriormente (detectado por dispositivo).");
//             setStep('played'); // O mostrar una pantalla de "Ya jugaste"
//         }

//         return () => {
//             document.getElementById('PluckingRooster__Game').style.overflow = 'visible'
//         }
//     }, []);

//     const handleRegister = async (e) => {
//         e.preventDefault();
        
//         // 1. Validar campos vacíos
//         if (!userData.fullName || !userData.email || !userData.phoneNumber) {
//             showMessage({ type: MESSAGE_TYPE.BAD, text: `Completa todos los campos` });
//             return;
//         }

//         setIsLoading(true); // Bloqueamos botón

//         // 2. NUEVO: Validación de Inyección SQL
//         const isNameThreat = await BLValidateSqlInjection(userData.fullName);
//         const isEmailThreat = await BLValidateSqlInjection(userData.email);
//         const isPhoneThreat = await BLValidateSqlInjection(userData.phoneNumber);

//         if (isNameThreat || isEmailThreat || isPhoneThreat) {
//             setIsLoading(false);
//             showMessage({ type: MESSAGE_TYPE.BAD, text: `Caracteres no permitidos en el formulario.` });
//             return; // Bloqueamos el avance
//         }

//         // 1. VALIDAMOS CONTRA EL BACKEND
//         const validation = await BLValidatePlayer(userData.email, userData.phoneNumber);

//         setIsLoading(false); // Desbloqueamos

//         if (!validation.success) {
//             setStep('played'); // "Ya has participado..."
//             return; // NO DEJA AVANZAR
//         }

//         document.getElementById('PluckingRooster__Game').style.overflow = 'hidden'
        
//         // Si pasa, iniciamos el juego
//         setStep('game');
//     };
    
//     // 2. Callback cuando el juego termina
//     const handleGameFinish = async (score) => {
//         // Guardamos en LocalStorage para bloquear futuros intentos inmediatos
//         localStorage.setItem('rooster_played', 'true');

//         document.getElementById('PluckingRooster__Game').style.overflow = 'visible'

//         setFinalScore(score);
//         setStep('sending');

//         // --- LLAMADA A LA CAPA BL ---
//         const result = await BLSubmitGame(userData, score);

//         if (result.success) {
//             // Éxito
//             //console.log("Respuesta Server:", result.data);
//             //alert(`¡Guardado! Tu ranking: ${result.data.score}`); // Asumiendo que el back devuelve el score
//             showMessage({ type: MESSAGE_TYPE.SUCCESS, text: `Puntaje enviado con éxito` });
//             setStep('done');
//         } else {
//             // Error (Ya manejado y traducido en el BL)
//             //alert(result.message);
//             showMessage({ type: MESSAGE_TYPE.BAD, text: 'Ha habido un error al intentar enviar tu puntaje. Inténtalo nuevamente.' });
//             setStep('resendPoints'); // Opcional: Podrías regresarlo a 'register' si quieres que intente con otro correo
//         }
//     };

//     const ResendPoints = async () => {
//         // Guardamos en LocalStorage para bloquear futuros intentos inmediatos
//         localStorage.setItem('rooster_played', 'true');

//         document.getElementById('PluckingRooster__Game').style.overflow = 'visible'

//         //setFinalScore(score);
//         setStep('sending');

//         // --- LLAMADA A LA CAPA BL ---
//         const result = await BLSubmitGame(userData, finalScore);

//         if (result.success) {
//             // Éxito
//             //console.log("Respuesta Server:", result.data);
//             //alert(`¡Guardado! Tu ranking: ${result.data.score}`); // Asumiendo que el back devuelve el score
//             showMessage({ type: MESSAGE_TYPE.SUCCESS, text: `Puntuación enviada con éxito` });
//             setStep('done');
//         } else {
//             // Error (Ya manejado y traducido en el BL)
//             //alert(result.message);
//             showMessage({ type: MESSAGE_TYPE.BAD, text: '¡Ups! Ha habido un error al intentar enviar tu puntaje' });
//             setStep('done'); // Opcional: Podrías regresarlo a 'register' si quieres que intente con otro correo
//         }
//     };

    
//     return (
//         <div id='PluckingRooster__Game' style={{ width: '100vw', height: '100vh' }}>
            
//             {step === 'register' && (
//                 <>
//                     <div className="container flex flex-col justify-center h-full bg-gray-100 pb-5"> {/* p-10 gap-4 */}
//                         <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />
//                         <p className="SelfieFan__Fan__Title">¡Bienvenid@ Aficionad@!</p>
//                         <p className="SelfieFan__Fan__Text--Center">Participa por un regalo especial.</p>
//                         <p className='Messages__Fan__Text--Center'>Obtén puntos cada vez que le pegues al gallito</p>

//                         <p className='Messages__Fan__Text--Center'>La persona que obtenga más puntos y más rápido será ganador(a)</p>

//                         <hr />

//                         <p className='SelfieFan__Fan__Title mt-4'>¡Únete al juego!</p>

//                         <label className='PluckingRooster__Instructions__Form__Labels' htmlFor='fullName'>Escribe tu nombre completo</label>
//                         <input id="fullName" name="fullName" placeholder="Escribe tu nombre" onChange={handleInputChange} className="PluckingRooster__Instructions__Form__Inputs" />

//                         <label className='PluckingRooster__Instructions__Form__Labels' htmlFor='name'>Correo electrónico</label>
//                         <input id="email" name="email" placeholder="Escribe tu correo" onChange={handleInputChange} className="PluckingRooster__Instructions__Form__Inputs" />

//                         <label className='PluckingRooster__Instructions__Form__Labels' htmlFor='phoneNumber'>WhatsApp o Teléfono</label>
//                         <input id="phoneNumber" name="phoneNumber" placeholder="Ej. 4441234567" onChange={handleInputChange} className="PluckingRooster__Instructions__Form__Inputs" />
                        
//                         <label className='PluckingRooster__Instructions__Form__Labels' htmlFor='phoneNumber'>¿Con quién nos acompañas hoy?</label>
//                         {/* Select simple para Acompañante */}
//                         <select name="companionType" onChange={handleInputChange} className='PluckingRooster__Instructions__Form__List'>
//                             <option value="amigos">Amig@s</option>
//                             <option value="familia">Familia</option>
//                             <option value="pareja">Pareja</option>
//                             <option value="trabajo">Compañer@s de trabajo</option>
//                             <option value="solo">Sol@</option>
//                         </select>

//                         {isLoading ? (
//                             <button className="Btn__Adsl--RedOutline PluckingRooster__Instructions__Form__Button" disabled={false}>Iniciando juego...</button>
//                         ) : (
//                             <button onClick={handleRegister} className="Btn__Adsl--Red PluckingRooster__Instructions__Form__Button">Jugar ahora</button>
//                         )}
//                     </div>

//                     <footer className="text-center mt-3 FooterCredits">
//                         Hecho con ♥ por <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=footer&utm_campaign=fdm_capitanescdmx' target='_blank' className='text-dark'>Five Digital Minds</a> | 2026
//                     </footer>
//                 </>
//             )}

//             {step === 'game' && (
//                 <PluckingRoosterGame onGameFinish={handleGameFinish} initialDuration={15} />
//             )}

//             {step === 'sending' && (
//                 <>
//                     <div className="container flex flex-col justify-center h-full bg-gray-100 pb-5">
//                         <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia mt-3" alt="Logo" />
//                         <p className="SelfieFan__Fan__Title mt-3">¡Muy bien{(userData && userData?.fullName && userData.fullName !== '') && ` ${userData.fullName}`}!</p>
//                         <p className="SelfieFan__Fan__Text--Center">Un momento... estamos guardando tu puntuación.</p>
//                         <p className="SelfieFan__Fan__Text--Center">{finalScore} puntos</p>
//                         <p className="SelfieFan__Fan__Text--Center">No salgas de esta pantalla.</p>
//                     </div>

//                     <footer className="text-center mt-3 FooterCredits">
//                         Hecho con ♥ por Five Digital Minds | 2026
//                     </footer>
//                 </>
//             )}

//             {step === 'done' && (
//                 <>
//                     <div className="SelfieFan__Sent container">
//                         <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia mt-3" alt="Logo" />
//                         <p className="fs-1 mb-0 text-success"><i className="bi bi-check-circle-fill"></i></p>
//                         <p className="SelfieFan__Sent__Title mt-3 mb-0">¡Listo!</p>
//                         <p className='Messages__Fan__Text--Center mb-0'>Tu puntaje ha sido enviado correctamente</p>
//                         <p className='Messages__Fan__Text--Center mb-0'>¡{finalScore} puntos!</p>
//                         <p className='Messages__Fan__Text--Center mb-0'>Podrás ir viendo en la pantalla del estadio el ranking para saber si has sido ganador(a)</p>
                        
//                         <hr />

//                         <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='SelfieFan__Sent__Banner'>
//                             <img src='/img/advertising/fdm/banner/five-digital-minds-agradecimiento.gif' alt='Publicidad' className='d-block m-auto SelfieFan__Sent__Banner__Image' />
//                         </a>
//                         <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center d-block'>Contactar ahora</a>

//                         <hr />

//                         <p className='text-center mb-0'>¿Quieres conocer más de esta tecnología?</p>
//                         <p className='text-center mb-0'>Five Digital Minds está listo para ti</p>
//                         <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner_text&utm_campaign=fdm_capitanescdmx' target='_blank' className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center'>Contactar ahora</a>
//                     </div>

//                     <footer className="text-center mt-3 FooterCredits">
//                         Hecho con ♥ por <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=footer&utm_campaign=fdm_capitanescdmx' target='_blank' className='text-dark'>Five Digital Minds</a> | 2026
//                     </footer>
//                 </>
//             )}

//             {step === 'played' && (
//                 <>
//                     <div className="SelfieFan__Sent container">
//                         <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia mt-3" alt="Logo" />
//                         <p className="fs-1 mb-0 text-success"><i className="bi bi-check-circle-fill"></i></p>
//                         <p className="SelfieFan__Sent__Title mt-3 mb-0">Gracias por tu participación</p>
//                         <p className='Messages__Fan__Text--Center mb-0'>Tu puntaje fue enviado correctamente</p>
//                         <p className='Messages__Fan__Text--Center mb-0'>Podrás ir viendo en la pantalla del estadio el ranking para saber si has sido ganador(a)</p>
                        
//                         <hr />

//                         <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='SelfieFan__Sent__Banner'>
//                             <img src='/img/advertising/fdm/banner/five-digital-minds-agradecimiento.gif' alt='Publicidad' className='d-block m-auto SelfieFan__Sent__Banner__Image' />
//                         </a>
//                         <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center d-block'>Contactar ahora</a>

//                         <hr />

//                         <p className='text-center mb-0'>¿Quieres conocer más de esta tecnología?</p>
//                         <p className='text-center mb-0'>Five Digital Minds está listo para ti</p>
//                         <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner_text&utm_campaign=fdm_capitanescdmx' target='_blank' className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center'>Contactar ahora</a>
//                     </div>

//                     <footer className="text-center mt-3 FooterCredits">
//                         Hecho con ♥ por <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=footer&utm_campaign=fdm_capitanescdmx' target='_blank' className='text-dark'>Five Digital Minds</a> | 2026
//                     </footer>
//                 </>
//             )}

//             {step === 'resendPoints' && (
//                 <>
//                     <div className="SelfieFan__Sent container">
//                         <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia mt-3" alt="Logo" />
//                         <p className="fs-1 mb-0 text-danger"><i className="bi bi-x-circle-fill"></i></p>
//                         <p className="mb-0">No ha sido posible enviar tu puntaje. Inténtalo nuevamente con el botón Enviar mi puntaje</p>
//                         <button type='button' className='Btn__Adsl--RedOutlineTransparent mx-auto' onClick={() => ResendPoints()}>Enviar mi puntaje</button>
                        
//                         <hr />

//                         <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='SelfieFan__Sent__Banner'>
//                             <img src='/img/advertising/fdm/banner/five-digital-minds-agradecimiento.gif' alt='Publicidad' className='d-block m-auto SelfieFan__Sent__Banner__Image' />
//                         </a>
//                         <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner&utm_campaign=fdm_capitanescdmx' target='_blank' rel="noreferrer" className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center d-block'>Contactar ahora</a>

//                         <hr />

//                         <p className='text-center mb-0'>¿Quieres conocer más de esta tecnología?</p>
//                         <p className='text-center mb-0'>Five Digital Minds está listo para ti</p>
//                         <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=banner_text&utm_campaign=fdm_capitanescdmx' target='_blank' className='Btn__Adsl--RedOutline m-auto text-decoration-none text-center'>Contactar ahora</a>
//                     </div>

//                     <footer className="text-center mt-3 FooterCredits">
//                         Hecho con ♥ por <a href='https://fivedigitalminds.com/?utm_source=rooster_web&utm_medium=footer&utm_campaign=fdm_capitanescdmx' target='_blank' className='text-dark'>Five Digital Minds</a> | 2026
//                     </footer>
//                 </>
//             )}
//         </div>
//     );
// };

// export { PluckingRooster };